<template>
  <div>
    <h2 style="margin-bottom: 8px; font-weight: 600">
      <span class="mdi mdi-email-check-outline" style="margin-right: 8px"></span>テンプレート
    </h2>
    <b-tabs v-model="activeTabInfo">
      <!-- メールテンプレート -->
      <b-tab-item label="メールテンプレート">
        <div style="text-align: left; margin-top: 16px; margin-bottom: 8px; font-weight: 600;">
          <a style="margin-right: 4px;" @click="changeStep('Email', 0)">
            <span class="mdi mdi-chevron-right-box-outline" style="margin-right: 4px;"></span>メールテンプレート一覧
          </a>
          <a style="margin-right: 4px;" v-if="stepEmail==1">
            / <span class="mdi mdi-email" style="margin-right: 4px;"></span>{{editingTemplate.name}}
          </a>
        </div>

        <div v-if="stepEmail==0">
          <div style="display: flex; margin-bottom: 8px;">
            <input class="input is-small" style="width: calc(100% - 56px); border-radius: 0;" placeholder="メールテンプレート名" v-model="createTamplateName"/>
            <button class="button is-small is-primary" style="width: 56px; border-radius: 0;" @click="createCompanyEmailTemplate(createTamplateName); createTamplateName=null;" :disabled="!createTamplateName">+ 追加</button>
          </div>
          <table class="disp-scroll" style="height: calc(100vh - 320px);">
            <tr style="display: table;">
              <th style="width: 60px;">移動</th>
              <th style="width: 60px;">順番</th>
              <th style="width: calc(100% - 60px); max-width: calc(100% - 60px); min-width: calc(100% - 60px);">メールテンプレート名/アクション名</th>
              <th style="width: 60px;">削除</th>
            </tr>
            <draggable id="story-list" :list="emailTemplates" @end="saveColumnOrder('Email', emailTemplates)" :options="{animation: 300, group: { name: 'TEMP', pull: 'clone', put: false}, handle: '.drag-button'}">
              <tr style="display: table;" v-for="(t, i) in emailTemplates" :key="i + '-col'">
                <td style="width: 60px; vertical-align: middle; padding: 0; overflow: hidden;">
                  <button class="drag-button trans-btn"><span class="mdi mdi-drag mdi-24px"></span></button>
                </td>
                <td style="width: 60px; vertical-align: middle;">{{t.order_type + 1}}</td>
                <td style="width: calc(100% - 60px); max-width: calc(100% - 60px); min-width: calc(100% - 60px); text-align: left; vertical-align: middle;  cursor: pointer; text-decoration:underline;"
                  @click="changeStep('Email', 1); selectTemplate('Email', i)">
                  {{t.name}}
                </td>
                <td style="width: 60px; text-align: center; vertical-align: middle; cursor: pointer;" @click="del(t)">
                  <span class="mdi mdi-delete" />
                </td>
              </tr>
            </draggable>
          </table>
        </div>
        <div v-else-if="stepEmail==1">
          <!-- 0件の時の新規作成中 -->
          <div
            style="
              position: absolute;
              top: 0;
              right: 0;
              height: 100%;
              width: 40%;
              min-width: 400px;
              background: rgba(255, 255, 255, 0.5);
              z-index: 202;
            "
            v-if="emailTemplates.length == 0"
          >
            <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
          </div>
          <div
            style="display: flex; align-items: center; margin: 16px 0px 8px"
            v-if="emailTemplates.length > 0"
          >
            <p style="text-align: left; font-size: smaller; width: 150px">
              <span class="mdi mdi-note-text" style="margin-right: 8px"></span>メールテンプレート
            </p>
            <select
              v-model="modifyTemplateIndexEmail"
              class="select is-small"
              style="width: calc(100% - 176px); margin-right: 8px"
            >
              <option :value="i" v-for="(t, i) in emailTemplates" :key="i + '-templatesel'">
                {{ t.name }}
              </option>
            </select>
            <button
              @click="createCompanyEmailTemplate()"
              class="button is-small is-primary"
              style="border-radius: 4px"
            >
              <span class="mdi mdi-plus"></span>
            </button>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600">
            <p style="margin-right: 4px; font-size: smaller; width: 120px; text-align: left">
              テンプレート名:
            </p>
            <input
              class="input is-small"
              v-model="editingTemplate.name"
              v-if="emailTemplates.length > 0"
            />
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600">
            <p style="margin-right: 4px; font-size: smaller; width: 120px; text-align: left">FROM:</p>
            <input
              class="input is-small"
              v-model="editingTemplate.from_email"
              v-if="emailTemplates.length > 0"
            />
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600">
            <p style="margin-right: 4px; font-size: smaller; width: 120px; text-align: left">CC:</p>
            <input
              class="input is-small"
              v-model="editingTemplate.cc_email"
              v-if="emailTemplates.length > 0"
            />
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600">
            <p style="margin-right: 4px; font-size: smaller; width: 120px; text-align: left">件名:</p>
            <input
              class="input is-small"
              v-model="editingTemplate.title"
              v-if="emailTemplates.length > 0"
            />
          </div>
          <quill-editor
            class="mail-box"
            v-model="editingTemplate.template"
            ref="quillEditor"
            :options="options"
            v-if="emailTemplates.length > 0"
          >
          </quill-editor>
          <button
            @click="updateCompanyEmailTemplate(editingTemplate)"
            style="margin-top: 4px"
            class="button is-small is-fullwidth"
          >
            <span class="mdi mdi-content-save" style="margin-right: 8px"></span>保存
          </button>
          <button
            @click="del(editingTemplate)"
            style="margin-top: 4px"
            class="button is-danger is-small is-fullwidth"
            v-if="emailTemplates.length > 1"
          >
            <span class="mdi mdi-delete" style="margin-right: 8px"></span>削除
          </button>
          <div style="display: flex; align-items: center; margin-top: 8px">
            <p style="text-align: left; font-size: smaller; width: 150px">
              <span class="mdi mdi-robot" style="margin-right: 8px"></span>ロボリンク
            </p>
            <select
              v-model="editingTemplate.robo"
              class="select is-small"
              style="width: calc(100% - 176px); margin-right: 8px"
            >
              <template v-for="(c, i) in isConfirmChatbot(chatbots)">
                <option :key="i + '-tempbot'" :value="c.bot_id" v-if="!c.is_archive">
                  {{ c.name }}
                </option>
              </template>
            </select>
            <button
              class="button is-small is-primary"
              style="border-radius: 4px"
              @click="
                helpMessage(
                  '__robo_url__とメール本文に挿入することで自動的に設定されたロボのリンクが作成されます。'
                )
              "
            >
              <span class="mdi mdi-help-circle-outline"></span>
            </button>
          </div>
          <div style="display: flex; align-items: center; margin-top: 8px">
            <p style="text-align: left; font-size: smaller; width: 150px">
              <span class="mdi mdi-message-video" style="margin-right: 8px"></span>Web会議リンク
            </p>
            <select
              v-model="editingTemplate.video_user"
              class="select is-small"
              style="width: calc(100% - 176px); margin-right: 8px"
            >
              <template v-for="(u, i) in users">
                <option :key="i + '-tempuser'" :value="u.user_hash">
                  {{ u.username }}
                </option>
              </template>
            </select>
            <button
              class="button is-small is-primary"
              style="border-radius: 4px"
              @click="
                helpMessage(
                  '__video_url__とメール本文に挿入することで自動的に設定されたWeb会議のリンクが作成されます。'
                )
              "
            >
              <span class="mdi mdi-help-circle-outline"></span>
            </button>
          </div>
          <div style="display: flex; align-items: center; margin-top: 8px">
            <p style="text-align: left; font-size: smaller; width: 150px">
              <span class="mdi mdi-file-video" style="margin-right: 8px"></span>録画面接リンク
            </p>
            <select
              v-model="editingTemplate.record"
              class="select is-small"
              style="width: calc(100% - 176px); margin-right: 8px"
            >
              <template v-for="(r, i) in recordingInterviews">
                <option :key="i + '-temprecord'" :value="r.id">
                  {{ r.name }}
                </option>
              </template>
            </select>
            <button
              class="button is-small is-primary"
              style="border-radius: 4px"
              @click="
                helpMessage(
                  '__record_url__とメール本文に挿入することで自動的に設定された録画面接のリンクが作成されます。'
                )
              "
            >
              <span class="mdi mdi-help-circle-outline"></span>
            </button>
          </div>
        </div>
        <!-- 置換説明 -->
        <template>
          <div class="desc">
            <p>※1<span style="font-weight: bold">__applicant__</span>と入力すると訪問者のお名前に沿って変換されます。</p>
            <p>※2<span style="font-weight: bold">__date_modify__</span>とメール内容に入力すると日程自動調整で設定されていた場合に訪問者向け日程変更リンクに変換されます。</p>
            <p>※3<span style="font-weight: bold">__received_form__</span>とメール内容に入力すると返信用フォームのリンクに変換されます。</p>
            <p>※4<span style="font-weight: bold">__カスタムカラム名__</span>とメール内容に入力するとカスタムカラムの内容に変換されます。 </p>
          </div>
        </template>
      </b-tab-item>
      <!-- SMSテンプレート -->
      <b-tab-item label="SMSテンプレート">
        <div v-if="user.companySMSTEL">
          <div style="text-align: left; margin-top: 16px; margin-bottom: 8px; font-weight: 600;">
            <a style="margin-right: 4px;" @click="changeStep('SMS', 0)">
              <span class="mdi mdi-chevron-right-box-outline" style="margin-right: 4px;"></span>SMSテンプレート一覧
            </a>
            <a style="margin-right: 4px;" v-if="stepSMS==1">
              / <span class="mdi mdi-email" style="margin-right: 4px;"></span>{{editingTemplate.name}}
            </a>
          </div>

          <div class="disp-scroll" v-if="stepSMS==0">                 
            <div style="display: flex; margin-bottom: 8px;">
              <input class="input is-small" style="width: calc(100% - 56px); border-radius: 0;" placeholder="SMSテンプレート名" v-model="createTamplateName"/>
              <button class="button is-small is-primary" style="width: 56px; border-radius: 0;" @click="createCompanySMSTemplate(createTamplateName); createTamplateName=null;" :disabled="!createTamplateName">+ 追加</button>
            </div>
            <table class="disp-scroll" style="height: calc(100vh - 195px);">
              <tr style="display: table;">
                <th style="width: 60px;">移動</th>
                <th style="width: 60px;">順番</th>
                <th style="width: calc(100% - 60px); max-width: calc(100% - 60px); min-width: calc(100% - 60px);">SMSテンプレート名/アクション名</th>
                <th style="width: 60px;">削除</th>
              </tr>
              <draggable id="story-list" :list="SMSTemplates" @end="saveColumnOrder('SMS', SMSTemplates)" :options="{animation: 300, group: { name: 'TEMP', pull: 'clone', put: false}, handle: '.drag-button'}">
                <tr style="display: table;" v-for="(t, i) in SMSTemplates" :key="i + '-col'">
                  <td style="width: 60px; vertical-align: middle; padding: 0; overflow: hidden;">
                    <button class="drag-button trans-btn"><span class="mdi mdi-drag mdi-24px"></span></button>
                  </td>
                  <td style="width: 60px; vertical-align: middle;">{{t.order_type + 1}}</td>
                  <td style="width: calc(100% - 60px); max-width: calc(100% - 60px); min-width: calc(100% - 60px); text-align: left; vertical-align: middle;  cursor: pointer; text-decoration:underline;"
                    @click="changeStep('SMS', 1); selectTemplate('SMS',i)">
                    {{t.name}}
                  </td>
                  <td style="width: 60px; text-align: center; vertical-align: middle; cursor: pointer;" @click="delSMS(t)">
                    <span class="mdi mdi-delete" />
                  </td>
                </tr>
              </draggable>
            </table>
          </div>
          <div v-else-if="stepSMS==1">
            <!-- 0件の時の新規作成中 -->
            <div
              style="
                position: absolute;
                top: 0;
                right: 0;
                height: 100%;
                width: 40%;
                min-width: 400px;
                background: rgba(255, 255, 255, 0.5);
                z-index: 202;
              "
              v-if="SMSTemplates.length == 0"
            >
              <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
            </div>
            <div
              style="display: flex; align-items: center; margin: 16px 0px 8px"
              v-if="emailTemplates.length > 0"
            >
              <p style="text-align: left; font-size: smaller; width: 150px">
                <span class="mdi mdi-note-text" style="margin-right: 8px"></span>SMSテンプレート
              </p>
              <select
                v-model="modifyTemplateIndexSMS"
                class="select is-small"
                style="width: calc(100% - 176px); margin-right: 8px"
              >
                <option :value="i" v-for="(t, i) in SMSTemplates" :key="i + '-templatesel'">
                  {{ t.name }}
                </option>
              </select>
              <button
                @click="createCompanySMSTemplate()"
                class="button is-small is-primary"
                style="border-radius: 4px"
              >
                <span class="mdi mdi-plus"></span>
              </button>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600">
              <p style="margin-right: 4px; font-size: smaller; width: 120px; text-align: left">
                テンプレート名:
              </p>
              <input
                class="input is-small"
                v-model="editingTemplate.name"
                v-if="SMSTemplates.length > 0"
              />
            </div>
            <textarea
              class="textarea input"
              maxlength="670" 
              v-model="SMStemp"
              v-if="SMSTemplates.length > 0"
            >
            </textarea>
            <button
              @click="updSMS()"
              style="margin-top: 4px"
              class="button is-small is-fullwidth"
            >
              <span class="mdi mdi-content-save" style="margin-right: 8px"></span>保存
            </button>
            <button
              @click="delSMS(editingTemplate)"
              style="margin-top: 4px"
              class="button is-danger is-small is-fullwidth"
              v-if="SMSTemplates.length > 1"
            >
              <span class="mdi mdi-delete" style="margin-right: 8px"></span>削除
            </button>
            <div style="display: flex; align-items: center; margin-top: 8px">
              <p style="text-align: left; font-size: smaller; width: 150px">
                <span class="mdi mdi-robot" style="margin-right: 8px"></span>ロボリンク
              </p>
              <select
                v-model="editingTemplate.robo"
                class="select is-small"
                style="width: calc(100% - 176px); margin-right: 8px"
              >
                <template v-for="(c, i) in isConfirmChatbot(chatbots)">
                  <option :key="i + '-tempbot'" :value="c.bot_id" v-if="!c.is_archive">
                    {{ c.name }}
                  </option>
                </template>
              </select>
              <button
                class="button is-small is-primary"
                style="border-radius: 4px"
                @click="
                  helpMessage(
                    '__robo_url__とメール本文に挿入することで自動的に設定されたロボのリンクが作成されます。'
                  )
                "
              >
                <span class="mdi mdi-help-circle-outline"></span>
              </button>
            </div>
            <div style="display: flex; align-items: center; margin-top: 8px">
              <p style="text-align: left; font-size: smaller; width: 150px">
                <span class="mdi mdi-message-video" style="margin-right: 8px"></span>Web会議リンク
              </p>
              <select
                v-model="editingTemplate.video_user"
                class="select is-small"
                style="width: calc(100% - 176px); margin-right: 8px"
              >
                <template v-for="(u, i) in showUsers">
                  <option :key="i + '-tempuser'" :value="u.user_hash">
                    {{ u.username }}
                  </option>
                </template>
              </select>
              <button
                class="button is-small is-primary"
                style="border-radius: 4px"
                @click="
                  helpMessage(
                    '__video_url__とメール本文に挿入することで自動的に設定されたWeb会議のリンクが作成されます。'
                  )
                "
              >
                <span class="mdi mdi-help-circle-outline"></span>
              </button>
            </div>
            <div style="display: flex; align-items: center; margin-top: 8px">
              <p style="text-align: left; font-size: smaller; width: 150px">
                <span class="mdi mdi-file-video" style="margin-right: 8px"></span>録画面接リンク
              </p>
              <select
                v-model="editingTemplate.record"
                class="select is-small"
                style="width: calc(100% - 176px); margin-right: 8px"
              >
                <template v-for="(r, i) in recordingInterviews">
                  <option :key="i + '-temprecord'" :value="r.id">
                    {{ r.name }}
                  </option>
                </template>
              </select>
              <button
                class="button is-small is-primary"
                style="border-radius: 4px"
                @click="
                  helpMessage(
                    '__record_url__とメール本文に挿入することで自動的に設定された録画面接のリンクが作成されます。'
                  )
                "
              >
                <span class="mdi mdi-help-circle-outline"></span>
              </button>
            </div>
            <!-- 置換説明 -->
            <template>
              <div class="desc">
                <p class="comment">(※1) 送付内容は670文字以内でお願いいたします。</p>
                <p class="comment">(※2) SMSの送付元が表示されないため、本文中に企業名の入力をお願いいたします。</p>
                <p class="comment">(※3) <span style="font-weight: bold">__applicant__</span>と入力すると訪問者のお名前に沿って変換されます。</p>
                <p class="comment">(※4) <span style="font-weight: bold">__date_modify__</span>とメール内容に入力すると日程自動調整で設定されていた場合に訪問者向け日程変更リンクに変換されます。</p>
                <p class="comment">(※5) ロボリンクに指定したロボにミニロボが設定されている場合、応募者のカスタムカラムにミニロボ名が設定されている場合にのみ、変換が可能です。</p>
              </div>
            </template>
          </div>
        </div>
        <div v-else>
          <div style="display: flex; align-items: center; margin: 16px 0px 8px">
            <p class="comment">SMS送受信機能の利用をご希望の場合、弊社へお問い合わせください。</p>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import controlLogMixin from '@/mixins/controlLogMixin'
import draggable       from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  props: {
    chatbots: {
      type: Array,
      required: true
    },
    recordingInterviews: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    emailTemplates: {
      type: Array,
      required: true
    },
    createCompanyEmailTemplate: {
      type: Function,
      required: true
    },
    updateCompanyEmailTemplate: {
      type: Function,
      required: true
    },
    SMSTemplates: {
      type: Array,
      required: true,
    },
    createCompanySMSTemplate: {
      type: Function,
      required: true,
    },
    updateCompanySMSTemplate: {
      type: Function,
      required: true,
    },
    deleteCompanySMSTemplate: {
      type: Function,
      required: true,
    },
    deleteCompanyEmailTemplate: {
      type: Function,
      required: true
    },
    copyLink: {
      type: Function,
      required: true
    },
    saveColumnOrder: {
      type: Function,
      required: true
    }
  },
  mixins: [
    controlLogMixin
  ],
  data() {
    return {
      modifyTemplateIndexEmail: 0,
      modifyTemplateIndexSMS: 0,
      editingTemplate: null,
      activeTabInfo: 0,
      SMStemp: "",
      stepEmail: 0,
      stepSMS: 0,
      createTamplateName: null,
    }
  },
  created () {
    this.changeEditingTemplateEmail(this.modifyTemplateIndexEmail)
  },
  watch: {
    modifyTemplateIndexEmail () {
      this.changeEditingTemplateEmail(this.modifyTemplateIndexEmail)
    },
    modifyTemplateIndexSMS () {
      this.changeEditingTemplateSMS(this.modifyTemplateIndexSMS)
    },
    activeTabInfo(){
      this.activeTabInfo == 0 ? this.changeEditingTemplateEmail(this.modifyTemplateIndexEmail) : this.changeEditingTemplateSMS(this.modifyTemplateIndexSMS)
    },
    'emailTemplates.length'(newVal, oldVal) {
      this.modifyTemplateIndexEmail = newVal < oldVal ? 0 : this.emailTemplates.length - 1
      this.changeEditingTemplateEmail(this.modifyTemplateIndexEmail)
    },
    'SMSTemplates.length'(newVal, oldVal) {
      this.modifyTemplateIndexSMS = newVal < oldVal ? 0 : this.SMSTemplates.length - 1
      this.changeEditingTemplateSMS(this.modifyTemplateIndexSMS)
    },
  },
  computed: {
    showUsers () {
        // ログイン不可ユーザーを表示しない
        return this.users.filter(user => {return user.permission < 3})
    },
  },
  methods: {
    changeEditingTemplateEmail(index) {
      this.editingTemplate = { ...this.emailTemplates[index] }
    },
    changeEditingTemplateSMS(index) {
      this.editingTemplate = { ...this.SMSTemplates[index] }
      this.SMStemp = this.SMSTemplates[index].template
    },
    updSMS() {
      this.editingTemplate.template = this.SMStemp
      this.updateCompanySMSTemplate(this.editingTemplate)
    },
    del(temp) {
      if (window.confirm("本当に削除してもよろしいでしょうか？")) {
        this.sendControlLog('応募者管理　メールテンプレート削除', 'テンプレート設定にて、「削除」ボタンをクリックした。')
        this.deleteCompanyEmailTemplate(temp);
      } else {
        alert("キャンセルしました。");
      }
    },
    delSMS(temp) {
      if (window.confirm("本当に削除してもよろしいでしょうか？")) {
        this.sendControlLog('応募者管理　SMSテンプレート削除', 'テンプレート設定にて、「削除」ボタンをクリックした。')
        this.deleteCompanySMSTemplate(temp);
      } else {
        alert("キャンセルしました。");
      }
    },
    helpMessage(msg) {
      this.$buefy.dialog.alert({
        message: msg,
        confirmText: "閉じる"
      });
    },
    isConfirmChatbot (chatbots) {
      let confirmChatbots = []
      for (const c of chatbots) {
        if (c.is_confirm) {
          confirmChatbots.push(c)
        }
      }
      return confirmChatbots
    },
    changeStep (serv, v) {
      serv == 'Email' ? this.stepEmail = v : this.stepSMS = v
    },
    selectTemplate (serv, i) {
      serv == 'Email' ? this.modifyTemplateIndexEmail = i : this.modifyTemplateIndexSMS = i
      serv == 'Email' ? this.changeEditingTemplateEmail(this.modifyTemplateIndexEmail) : this.changeEditingTemplateSMS(this.modifyTemplateIndexSMS)
    }
  }
};
</script>

<style scoped lang="scss">
.mail-box {
  height: calc(95% - 500px);
}
.comment {
  text-align: left;
  color: grey;
  font-size: 13px;
}

table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
  display: block;
  //overflow: scroll;
  height: calc(100% - 100px);
  table-layout: fixed;
}
table::-webkit-scrollbar {
  //width:  5px;
  //height: 5px;
  //visibility: hidden;
}
tr {
  width: 100%;
}
td,th {
  padding: 8px;
  margin: auto;
  font-size: smaller;
  border-style: solid;
  border-width: 1px;
  border-color: #AA0066;
}
td {
  text-align: left;
  //overflow: scroll;
  padding: 8px;
}
td > div::-webkit-scrollbar {
  //width:  5px;
  //height: 5px;
  //visibility: hidden;
}
th {
  color:#fff;
  background:#AA0066;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10000;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.trans-btn {
  width: 100%;
  height: 35px;
  background: transparent;
  border: none;
  cursor: pointer;
}
.desc {
  margin-top: 16px;
  p {
    font-size: 14px;
    text-align: left;
    color: gray;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/organisms/emails/EmailTemplateContents.vue